/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/
import { UserManager } from "oidc-client-ts";
import actionTypes from "../store/actions";
import store from "../store/store";
import constants from "../helper/constants";
import BusApiCall from "../helper/axios";
import { WebStorageStateStore } from "oidc-client-ts";
import LogoutHelper from "../helper/logoutHelper";
import { getAppDomain } from "../helper/getAppDomain";
// Get select tenant info from redux store start
const storeData = store.getState();
const authData = storeData.auth.tenantInfo;
var authority = "";
let searchOptions = window.location.search;

if (authData.tenantId) {
  var url = authData.wellknownUrl;
  url = url.replace("/.well-known/openid-configuration", "");
  authority = url.replace("${}", authData.realm);
}

const settings = {
  // authority: window.REACT_APP_OAUTH_AUTHORITY,
  // client_id: window.REACT_APP_OAUTH_CLIENT_ID,
  authority: authData.tenantId
    ? authData.baseUrl + authority
    : authData.authority,
  client_id: authData.clientId,
  redirect_uri: `${window.location.origin}/callback`,
  response_type: "code",
  scope: "openid profile offline_access",
  post_logout_redirect_uri: `${window.location.origin}/callback`,
  extraQueryParams: {
    navigateToLoginRequestUrl: true,
  },
  useRefreshToken: true,
  automaticSilentRenew: true,
  accessTokenExpiringNotificationTime: 60,
  revokeAccessTokenOnSignout: true,
  monitorSession: true,
  silent_redirect_uri: `${window.location.origin}/silentcallback`,
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  disablePKCE: (window.location.protocol === "https:" || window.location.protocol === "HTTPS:") ? false : true,
};
const userManager = new UserManager(settings);
var absoluteDomain = getAppDomain() || "";
userManager.events.addUserLoaded((args) => {
  userManager.getUser().then((user) => {
    localStorage.setItem("tokenInfo", JSON.stringify(user));
    if (
      window.location.protocol === "https:" ||
      window.location.protocol === "HTTPS:"
    ) {
      document.cookie =
        "access_token=" +
        user.access_token +
        "; domain=" +
        absoluteDomain +
        "; path=/; secure;";
    } else {
      document.cookie =
        "access_token=" +
        user.access_token +
        "; domain=" +
        absoluteDomain +
        "; path=/;";
    }
    if (
      window.location.protocol === "https:" ||
      window.location.protocol === "HTTPS:"
    ) {
      document.cookie =
        "id_token_hint=" +
        user.id_token +
        "; domain=" +
        absoluteDomain +
        "; path=/; secure;";
      document.cookie =
        "refresh_token=" +
        user.refresh_token +
        "; domain=" +
        absoluteDomain +
        "; path=/; secure;";
    } else {
      document.cookie =
        "id_token_hint=" +
        user.id_token +
        "; domain=" +
        absoluteDomain +
        "; path=/;";
      document.cookie =
        "refresh_token=" +
        user.refresh_token +
        "; domain=" +
        absoluteDomain +
        "; path=/;";
    }
    store.dispatch({
      type: actionTypes.REFRESH_USER_TOKEN,
      accessToken: user.access_token,
    });
    BusApiCall("POST", `${constants.busPublicServiceUrl}/auth/token`).then(
      (res) => { },
    );
  });
});

userManager.events.addSilentRenewError((error) => {
  if (navigator.onLine) {
    var time = 5;
    setInterval(() => {
      if (time > -1) {
        store.dispatch({
          type: actionTypes.SET_ERROR_MSG,
          errMsg: `Session expired. Redirecting you to login page in ${time}`,
          msgType: false,
        });
        time = time - 1;
      }
      if (time === 0) {
        LogoutHelper();
      }
    }, 1000);
  }
});

// Add online event listener to try silent sign-in when network is back
window.addEventListener("online", () => {
  console.log("[OIDC] Browser back online, attempting silent token renewal...");
  userManager
    .signinSilent()
    .then((user) => {
      console.log("[OIDC] Token successfully refreshed on reconnect.");
      localStorage.setItem("tokenInfo", JSON.stringify(user));
      if (
        window.location.protocol === "https:" ||
        window.location.protocol === "HTTPS:"
      ) {
        document.cookie =
          "access_token=" +
          user.access_token +
          "; domain=" +
          absoluteDomain +
          "; path=/; secure;";
      } else {
        document.cookie =
          "access_token=" +
          user.access_token +
          "; domain=" +
          absoluteDomain +
          "; path=/;";
      }
      if (
        window.location.protocol === "https:" ||
        window.location.protocol === "HTTPS:"
      ) {
        document.cookie =
          "id_token_hint=" +
          user.id_token +
          "; domain=" +
          absoluteDomain +
          "; path=/; secure;";
        document.cookie =
          "refresh_token=" +
          user.refresh_token +
          "; domain=" +
          absoluteDomain +
          "; path=/; secure;";
      } else {
        document.cookie =
          "id_token_hint=" +
          user.id_token +
          "; domain=" +
          absoluteDomain +
          "; path=/;";
        document.cookie =
          "refresh_token=" +
          user.refresh_token +
          "; domain=" +
          absoluteDomain +
          "; path=/;";
      }
      store.dispatch({
        type: actionTypes.REFRESH_USER_TOKEN,
        accessToken: user.access_token,
      });
    })
    .catch((err) => {
      console.error("[OIDC] Failed to refresh token on reconnect:", err);
    });
});

// userManager.events.addAccessTokenExpired(error => {
//     console.log('access token expired', error)
// })
// userManager.events.addUserSignedOut(error => {
//     console.log('user signed out', error)
// })
// userManager.events.addUserUnloaded(error => {
//     console.log('user unloaded', error)
// })
// userManager.events.addUserSessionChanged(error => {
//     console.log('user session changed', error)
// })

export default userManager;
